import Icon, { IconLoader } from './Icon';

export default Icon;
export { IconLoader };
